import { AppInstallPermission } from '@atlassian/mpac-services-client';
import React from 'react';
import SiteSelectorError from './SiteSelectorError';
const SiteSelectorPermissionErrorSection = props => {
  const {
    installPermission,
    isFreeApp
  } = props;
  if (installPermission === AppInstallPermission.CAN_INSTALL_FREE_AND_PAID) {
    return null;
  } else if (installPermission === AppInstallPermission.CANNOT_INSTALL) {
    return /*#__PURE__*/React.createElement(SiteSelectorError.CannotInstallAnyApps, null);
  } else if (installPermission === AppInstallPermission.CAN_INSTALL_FREE_ONLY) {
    return isFreeApp ? null : /*#__PURE__*/React.createElement(SiteSelectorError.CannotInstallPaidApps, null);
  } else {
    return /*#__PURE__*/React.createElement(SiteSelectorError.Unknown, null);
  }
};
export default SiteSelectorPermissionErrorSection;